import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReplaceFileIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 26,
	viewBox: "0 0 24 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6353 17.1885V20.2746C12.6353 21.1675 12.9699 22.0239 13.5657 22.6553C14.1615 23.2866 14.9695 23.6413 15.812 23.6413H21.239",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9619 19.3394L12.7544 17.1885L14.5468 19.3394",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.239 21.4899V18.4038C21.239 17.5109 20.9043 16.6546 20.3085 16.0232C19.7128 15.3918 18.9048 15.0371 18.0622 15.0371H12.6353",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.1508 19.3389L21.3584 21.4898L19.5659 19.3389",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9864 25H5.83018C4.54913 25 3.32055 24.4942 2.41472 23.5941C1.50888 22.6938 1 21.4731 1 20.2V16.468C1 12.3656 2.63989 8.43128 5.55895 5.53047C8.478 2.62966 12.4371 1 16.5652 1H17.9057C19.1866 1 20.4153 1.5057 21.3211 2.40588C22.2269 3.30606 22.7358 4.52696 22.7358 5.8V12.3279",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 16.8491C1 10.5871 7.52384 15.6354 11.3551 11.7035C15.1864 7.77159 10.2876 1 16.3962 1",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgReplaceFileIcon;
